import {
  GET_JURISDICTION_REQUEST,
  GET_JURISDICTION_SUCCESS,
  GET_JURISDICTION_FAILED,
  UPDATE_JURISDICTION_REQUEST,
  UPDATE_JURISDICTION_SUCCESS,
  UPDATE_JURISDICTION_FAILED,
} from './actionTypes';

const initialState = {
  jurisdiction: null,
  loading: false,
  error: null,
};

const jurisdictionsEditReducer = (state = initialState, {
  type, error, jurisdiction,
}) => {
  switch (type) {
    case GET_JURISDICTION_REQUEST:
      return { ...state, loading: true, jurisdiction: null };
    case GET_JURISDICTION_SUCCESS:
      return {
        ...state,
        jurisdiction,
        loading: false,
      };
    case GET_JURISDICTION_FAILED:
      return { ...state, loading: false, error };
    case UPDATE_JURISDICTION_REQUEST:
      return { ...state, loading: true };
    case UPDATE_JURISDICTION_SUCCESS:
      return {
        ...state,
        jurisdiction,
        loading: false,
      };
    case UPDATE_JURISDICTION_FAILED:
      return {
        ...state, loading: false, error, jurisdiction: { ...state.jurisdiction },
      };
    default:
      return state;
  }
};

export default jurisdictionsEditReducer;
